module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.createNotification()
      }
    }
  }, [_vm._v("Új értesítés létrehozása")])], 1), _vm._v(" "), (_vm.notifications.length <= 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "white",
      "font-size": "20px"
    }
  }, [_vm._v("\n\t\t\t..Betöltés..\n\t\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      staticClass: "card"
    }, [_c('md-input-container', [_c('label', [_vm._v("Értesítés címe")]), _vm._v(" "), _c('md-input', {
      model: {
        value: (notification.title),
        callback: function($$v) {
          _vm.$set(notification, "title", $$v)
        },
        expression: "notification.title"
      }
    })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Értesítés szövege")]), _vm._v(" "), _c('md-textarea', {
      model: {
        value: (notification.body),
        callback: function($$v) {
          _vm.$set(notification, "body", $$v)
        },
        expression: "notification.body"
      }
    })], 1), _vm._v(" "), (notification.options) ? _c('section', {
      staticClass: "card options"
    }, [_c('span', {
      staticClass: "subtitle"
    }, [_vm._v("Válaszlehetőségek")]), _vm._v(" "), _vm._l((notification.options), function(option) {
      return _c('div', [_c('md-input-container', [_c('label', [_vm._v("Válasz")]), _vm._v(" "), _c('md-input', {
        model: {
          value: (option.title),
          callback: function($$v) {
            _vm.$set(option, "title", $$v)
          },
          expression: "option.title"
        }
      })], 1)], 1)
    })], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "block actions row"
    }, [_c('div', {
      staticClass: "col-md-12 end-md"
    }, [_vm._v("\n\t\t\t\tÉrvényes: "), _c('date-picker', {
      staticClass: "date-picker",
      attrs: {
        "date": notification.targetDate,
        "option": _vm.option,
        "limit": _vm.limit
      }
    }), _vm._v(" "), _c('md-checkbox', {
      model: {
        value: (notification.published),
        callback: function($$v) {
          _vm.$set(notification, "published", $$v)
        },
        expression: "notification.published"
      }
    }, [_vm._v("Publikálva")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 start-md"
    }, [_c('md-button', {
      staticClass: "md-warn",
      nativeOn: {
        "click": function($event) {
          _vm.deleteNotification(notification)
        }
      }
    }, [_vm._v("Törlés")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-10 end-md"
    }, [_c('md-button', {
      staticClass: "md-accent",
      nativeOn: {
        "click": function($event) {
          _vm.pushNotification(notification)
        }
      }
    }, [_vm._v("Push értesítés küldése")]), _vm._v(" "), _c('md-button', {
      staticClass: "md-accent",
      nativeOn: {
        "click": function($event) {
          _vm.addOption(notification)
        }
      }
    }, [_vm._v("Válaszlehetőség hozzáadása")]), _vm._v(" "), _c('md-button', {
      staticClass: "md-primary",
      nativeOn: {
        "click": function($event) {
          _vm.saveNotification(notification)
        }
      }
    }, [_vm._v("Mentés")])], 1)])], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb35ab84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Notifications.vue
// module id = 559
// module chunks = 2